import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { GradesService } from 'src/app/grade-management/_services/grades.service';
import { GlobalService } from 'src/app/_services/global.service';
import { FlowService } from '../_services/flow.service';
import { InfoService } from '../_services/info.service';
import moment from 'moment';
import { AmplitudeService } from 'src/app/_services/amplitude.service';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { distinctUntilChanged, Subject, takeUntil, tap } from 'rxjs';
import { TimeZoneService } from 'src/app/_services/time-zone.service';


declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-dismissal-flow',
  templateUrl: './dismissal-flow.component.html',
  styleUrls: ['./dismissal-flow.component.scss']
})
export class DismissalFlowComponent implements OnInit {

  flowsArray = [];
  loading = true;
  dismissalStartedFlag = false;
  _grades = [];
  grades:any=[];
  overviewData;
  currLang;
  min_Pickup_Time;
  school_closing_time;
  current_time;
  formated_time;
  // raw "HH:mm:ss" behind formated_time , kept to re-format it when the language changes
  raw_error_time;
  today_name;
  today_grades_times:any=[];
  destroy$ = new Subject<void>(); 
  constructor(
    private flowService: FlowService,
    private globalService: GlobalService,
    private infoService: InfoService,
    private gradesService: GradesService,
    private dataService:DataService,
    private translate: TranslateService,
    private amplitudesService: AmplitudeService,
    private timeZoneService:TimeZoneService) {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)dismissal-flow_(f)getLang_(L)46' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.flowService.setFlowData(null);
  }

  ngOnInit(): void {
    // to remove the black screen and the stuck error msg popup if error message was just closed in sibling component 
      $('.modal').modal('hide');
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove();  
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)dismissal-flow_(f)getLang_(L)59' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
      // re-format the dismissal error time so AM/PM follows the new language
      this.convert12Format(this.raw_error_time);
    });
    this.getAllFlows();

    $('#add-flow-popup').on('hidden.bs.modal', () => {
      this.flowService.setFlowData(null);
    });
    $('#error-msg-popup').on('hidden.bs.modal', () => {
      this.getAllFlows();
    });
    this.flowService.getReload().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)dismissal-flow_(f)getReload_(L)72' , res);
      if (res) {
        this.getAllFlows();
        this.flowService.changeReloadFlag(false);
      }
    });
    this.dataService.getAllGrades().pipe(takeUntil(this.destroy$)).subscribe(res=>{
      //console.log('(c)dismissal-flow_(f)getAllGrades_(L)79' , res);
      this.grades=res
    })

    this.dataService.getSchoolInfo().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)dismissal-flow_(f)getSchoolInfo_(L)84' , res);
      let selectedSchool;
      selectedSchool = res.find(school=> school.selected == true);
      this.school_closing_time = this.timeZoneService.convertToLocalTime(selectedSchool.school_closing_time , "HH:mm:ss" , "HH:mm:ss");
      if (this.school_closing_time != null) {
        this.convert12Format(this.school_closing_time);
      }
    });
  }
  getAllFlows() {
    this.flowsArray = [];
    this.loading = true;
    this.flowService.getAllFlows().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)dismissal-flow_(f)getAllFlows_(L)97' , res);
      this.flowsArray = this.getDismissalTimesMappper(res);
      this.flowsArray.forEach(element => {
        element["steps"] = this.extractStages(element.name);
      })
      this.setOverviewData();
      this.loading = false;
    });
  }

  openAddFlowPopup(flowData: any = {}) {
    console.log('open flow' , flowData);
    
    this.amplitudesService.trackEvent('CTA.Add_Flow',{});
    this.today_grades_times = [];
    this.min_Pickup_Time=''
    this.getTime();
    //get which day of week is today 
    this.today_name = moment(new Date()).format('dddd');
    this._grades = flowData['grades'];
    if(this._grades !=undefined){
    // filter the grades that doesn't have dismissal_schedule
      this._grades = this._grades.filter(grade => grade.dismissal_schedule.length !== 0);
      this._grades.forEach(grade=>{
        // get the day of each grade that matches todays date
        let selectedDay = grade.dismissal_schedule.find(day=> day.day_of_week == this.today_name);
        //  push the time of each day found that matches todays date to today_grades_times Array 
        selectedDay.start_time?this.today_grades_times.push(selectedDay.start_time):console.log('no start time');
      })
      
      if (this.today_grades_times.length != 0) {
        //  return the grade with the minimum pickup starting time 
        // this.today_grades_times = this.today_grades_times.reduce(function (prev, curr) {
        //   return prev.start_time < curr.start_time ? prev : curr;
        // });
        // sort today_grades_times array from min to max times 
        this.today_grades_times.sort(function (a, b) {
          return a.start_time - b.start_time
      })
        // min pickup time is the first time in the sorted array 
        this.min_Pickup_Time = this.today_grades_times[0]; 
      }
      // console.log(this.today_grades_times);
      // console.log(this.min_Pickup_Time);
      // console.log(this.current_time);
      // console.log(this.school_closing_time);
      

      // if (this.school_closing_time != null) {
      //   if (this.min_Pickup_Time < this.current_time && this.current_time < this.school_closing_time) {
      //     flowData.dismissalStartedFlag = true;
      //   }
      //   // dismissal period isn't on , user can open the modal and edit grade 
      //   else {
      //     flowData.dismissalStartedFlag = false;
      //     this.flowService.setFlowData(flowData);
      //   }
      // }
      // else{
      //   flowData.dismissalStartedFlag = false;
      //   this.flowService.setFlowData(flowData);
      //   }
  
      switch (true) {
        //  Case 1 --> pickup starting time == true && school closing time == true 
        case this.today_grades_times.length != 0 && this.school_closing_time != null:
          // if current time bigger than min pickup time and less than school ending time , dismissal period is on and you can't edit flow
          if (this.min_Pickup_Time < this.current_time && this.current_time < this.school_closing_time) {
            flowData.dismissalStartedFlag = true;
          }
          // dismissal period isn't on , user can open the modal and edit flow 
          else {
            flowData.dismissalStartedFlag = false;
            this.flowService.setFlowData(flowData);
          }
          break;
        //  Case 2 --> pickup starting time == true && school closing time == false 
        case this.today_grades_times.length != 0 && this.school_closing_time == null:
          // if current time bigger than min pickup time , dismissal period is on and you can't edit flow
          if (this.min_Pickup_Time < this.current_time) {
            flowData.dismissalStartedFlag = true;
            this.convert12Format(this.min_Pickup_Time);
            //  this flag to toggle the error message in the template 
            flowData.beforeStartFlag = true;
          }
          // dismissal period isn't on , user can open the modal and edit flow 
          else {
            flowData.dismissalStartedFlag = false;
            flowData.beforeStartFlag = false;
            this.flowService.setFlowData(flowData);
          }
          break;
        //  Case 3 --> pickup starting time == false && school closing time == true 
        case this.today_grades_times.length == 0 && this.school_closing_time != null:
          // if current time less than  school ending time , dismissal period is on and you can't edit flow
          if (this.current_time < this.school_closing_time) {
            flowData.dismissalStartedFlag = true;
          }
          // dismissal period isn't on , user can open the modal and edit flow 
          else {
            flowData.dismissalStartedFlag = false;
            this.flowService.setFlowData(flowData);
          }
          break;
        //  Case 4 --> pickup starting time == false && school closing time == false 
        case this.today_grades_times.length == 0 && this.school_closing_time == null:
          // no min starting time and no shcool ending time , dismissal period isn't on and you can edit flow
          flowData.dismissalStartedFlag = false;
          this.flowService.setFlowData(flowData);
          break;
      }
  
      setTimeout(() => {
        $(".error-container").hide("slow", "linear");
        // switch the flag back to false , other wise it will still true and error will only show the first time 
        flowData.dismissalStartedFlag = false;
        flowData.beforeStartFlag = false;
      }, 8000);
    }
    else{
      if(!flowData.grades){

        this.dataService.sentGrades(this.grades);
      }
      flowData.dismissalStartedFlag = false;
      this.flowService.setFlowData(flowData);
    }
    // filter grades and return grades with pickup starting time 
   
  }


  setOverviewData() {
    let gates = [], guards = []; let grades = [];
    this.flowsArray.forEach(flow => {
      flow.grades.forEach(grade => {
        grades.push(grade);
        grade.gates.forEach(gate => {
          if (!gates.includes(gate.id)) {
            gates.push(gate.id);
          }
          gate.users.forEach(user => {
            if (!guards.includes(user.id)) {
              guards.push(user.id);
            }
          });
        });
      });
    });


    // here
    this.translate.get('init').pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)dismissal-flow_(f)translateInit_(L)248' , res);
      this.overviewDataList(gates, guards , grades);
    });
    // this.translate.onLangChange.subscribe(res => {
    //   this.overviewDataList(gates, guards , grades);
    // })
    this.translate.onLangChange.pipe(
      distinctUntilChanged((prev, curr) => prev.lang === curr.lang), // Only trigger if the language changes
      tap((res) => {
        //console.log('(c)dismissal-flow_(f)translateOnChange_(L)258' , res);
      this.overviewDataList(gates, guards , grades);
      }),
      takeUntil(this.destroy$) // Automatically unsubscribe when destroy$ emits
    )
    .subscribe();

  }
  overviewDataList(gates, guards , grades) {
    this.overviewData = [
      {
        header: this.translate.instant('dismissal-flow.flow'),
        content: [{
          count: gates.length,
          countFlag: true,
          name: this.translate.instant('dismissal-flow.gates'),
          statesFlag: false,
          error: null
        },
        {
          count: guards.length,
          countFlag: true,
          name: this.translate.instant('dismissal-flow.guards'),
          statesFlag: false,
          error: null
        },
        {
          count: grades.length,
          countFlag: true,
          name: this.translate.instant('dismissal-flow.grades'),
          statesFlag: false,
          error: null
        }]
      }
    ];

    console.log('overviewData', this.overviewData);
  }
  extractStages(name) {
    let stages = [];
    stages.push('R');
    for (let index = 1; index < name.length; index++) {
      stages.push(name[index]);
    }
    return stages;
  }

  getTime() {
    var now = new Date();
    // now.setHours(now.getHours() + 1); add if you want ksa timming 
    var hours = ('0' + now.getHours()).slice(-2);
    var mins = ('0' + now.getMinutes()).slice(-2);
    var sec = ('0' + now.getSeconds()).slice(-2);
    this.current_time = `${hours}:${mins}:${sec}`;
  }

  convert12Format(time) {
    if (!time) {
      return;
    }
    // keep the raw time so the meridiem can be re-translated when the language changes
    this.raw_error_time = time;
    let isArabic = this.currLang == 'ar';
    let pm: string = isArabic ? 'م' : 'PM';
    let am: string = isArabic ? 'ص' : 'AM';
    var timeString = time;
    var H = +timeString.substr(0, 2);
    var h = H % 12 || 12;
    var ampm = (H < 12 || H === 24) ? am : pm;
    timeString = h + timeString.substr(2, 3) + " " + ampm;
    this.formated_time = isArabic ? this.toArabicNumerals(timeString) : timeString;
  }

  // the arabicNumber pipe parses its input as a number , so it can't be used on a "10:00 م" string
  toArabicNumerals(value: string): string {
    const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return value.replace(/\d/g, digit => arabicNumerals[parseInt(digit, 10)]);
  }

  ngOnDestroy(): void {
    
  }

  getDismissalTimesMappper(flows:any){
    return flows.map((flow: any) => ({
      ...flow,
      grades: flow.grades.map((grade: any) => ({
        ...grade,
        dismissal_schedule: grade.dismissal_schedule.map((dismissal: any) => ({
          ...dismissal,
          start_time: this.timeZoneService.convertToLocalTime(dismissal.start_time,"HH:mm" , "HH:mm"),
        })),
      })),
    }));
  }

}
